import React from "react";
import MultiAccordionContents from "./MultiAccordionContents";

const MultiAccordion = ({
  data,
  videoAnim = false,
  itemLabel,
  itemValue,
}: any) => {
  return (
    <>
      <div
        className={`faq-container-landing ${videoAnim && `video-animation-bg`}`}
      >
        {!videoAnim && (
          <div className="faq-landing-title-container">
            <div dangerouslySetInnerHTML={{ __html: data?.title }} />
          </div>
        )}
        <div className={`faq-wrapper ${videoAnim && `faq-animation-wrapper`}`}>
          {data && data?.length > 0 && (
            <MultiAccordionContents data={data} itemLabel={itemLabel} itemValue={itemValue} />
          )}
        </div>
      </div>
    </>
  );
};

export default MultiAccordion;
